import React, {useState} from 'react';
import {useNavigate} from 'react-router-dom';
import axios from 'axios';
import Lock from '../../assets/icons/Lock.svg';

function MfaVerification() {
    const [mfaCode, setMfaCode] = useState('');
    const [error, setError] = useState('');
    const navigate = useNavigate();

    const baseURL = process.env.REACT_APP_API_BASE_URL;

    const handleMfaVerify = async () => {
        try {
            await axios.post(
                baseURL + '/auth/mfa-verify',
                {mfaCode},
                {withCredentials: true}
            );
            navigate('/dashboard');
        } catch (error) {
            setError('MFA-Verifizierung fehlgeschlagen. Bitte überprüfen Sie Ihren Code.');
            navigate('/login', {
                state: {
                    error:
                        'MFA-Verifizierung fehlgeschlagen. Bitte loggen Sie sich erneut ein und warten Sie auf einen neuen Code.',
                },
            });
        }
    };

    return (
        <div className="flex min-h-screen flex-col justify-center px-6 py-12 bg-gray-100 lg:px-8">
            <div className="sm:mx-auto sm:w-full sm:max-w-sm">
                <img
                    alt="AES"
                    src={Lock}
                    onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = '/fallback-logo.png';
                    }}
                    className="mx-auto h-16 w-auto"
                />
                <h2 className="mt-10 text-center text-2xl/9 font-bold tracking-tight text-gray-900">
                    MFA-Code eingeben
                </h2>
            </div>

            <div className="mt-10 sm:mx-auto sm:w-full sm:max-w-sm">
                {error && (
                    <div className="text-red-500 text-sm text-center bg-red-100 p-2 rounded mb-4">
                        {error}
                    </div>
                )}

                <form
                    className="space-y-6"
                    onSubmit={(e) => {
                        e.preventDefault();
                        handleMfaVerify();
                    }}
                >
                    <div>
                        <label htmlFor="mfaCode" className="block text-sm font-medium text-gray-900">
                            MFA-Code
                        </label>
                        <div className="mt-2">
                            <input
                                id="mfaCode"
                                name="mfaCode"
                                type="text"
                                required
                                value={mfaCode}
                                onChange={(e) => setMfaCode(e.target.value)}
                                className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 border border-gray-500 placeholder:text-gray-400 focus:border-indigo-600 sm:text-sm"
                                autoFocus
                            />
                        </div>
                    </div>

                    <div>
                        <button
                            type="submit"
                            className="flex w-full justify-center rounded-md bg-indigo-600 px-3 py-1.5 text-sm font-semibold text-white shadow-xs hover:bg-indigo-500 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                        >
                            Bestätigen
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default MfaVerification;
